export default () => {
    document.body.classList.add('no-scroll');

    const initialLoad = gsap.timeline({
        defaults: {
            ease: 'circ.inOut'
        },
        onComplete: () => {
            document.body.classList.remove('no-scroll');
        }
    });
    const loaderWrapper = document.querySelector('[data-loader-wrapper]');
    const cover = document.querySelector('[data-cover]');

    const logo = document.querySelector('[data-loader-logo]');
    const text = document.querySelector('[data-loader-text]');
    const mark = document.querySelector('[data-loader-mark]');

    const curtainBlack = document.querySelector('[data-curtain-black]');
    const curtainWhite = document.querySelector('[data-curtain-white]');
    const curtainRed = document.querySelector('[data-curtain-red]');

    initialLoad
        .set(curtainRed, { yPercent: 101 })
        .set(curtainBlack, { yPercent: 101 })
        .set(text, { xPercent: -101 })
        .set(logo, { xPercent: 32 })
        .set(cover, { autoAlpha: 0 })
        .set(mark, { autoAlpha: 0 })
        .addLabel('in') // Animate In the Loader Elements
        .to(curtainRed, { duration: 0.7, yPercent: -6 }, 'in')
        .to(curtainBlack, { duration: 0.6, yPercent: 0 }, 'in+=0.2')
        .fromTo(logo, { autoAlpha: 0, yPercent: -100 }, { duration: 0.3, autoAlpha: 1, yPercent: -20 }, '>-0.2')
        .to(text, { duration: 0.6, xPercent: 0 })
        .to(logo, { duration: 0.6, xPercent: 0 }, '<')
        .addLabel('out', '>0.4') // Load Out the Loader Elements
        .to(curtainRed, { duration: 0.6, yPercent: -101 }, 'out-=0.2')
        .to(curtainBlack, { duration: 0.6, yPercent: -101 }, 'out')
        .to(curtainWhite, { duration: 0.6, yPercent: -101 }, '>-0.3')
        .to(logo, { duration: 0.9, autoAlpha: 0, yPercent: -300 }, 'out')
        .set(loaderWrapper, { autoAlpha: 0 });
};
